// components/MissionVisionSection.jsx
import React from "react";
import globe from "../../assets/globe.webp";

const MissionVisionSection = () => {
  return (
    <div className="flex flex-col lg:flex-row justify-between items-center py-20 lg:py-40">
      {/* Left Section */}
      <div className="w-full lg:w-1/2 p-0 md:p-8 mb-10 lg:mb-0">
        <h2 className="text-3xl md:text-4xl text-white font-bold mb-4">
          Our mission
        </h2>
        <p className="mt-3 md:mt-5 text-sm md:text-md text-gray-300">
          Establish Chhattisgarh as a central IT hub for data storage and cloud
          solutions. Foster digital transformation through innovative,
          sustainable, and cost-effective solutions.
        </p>

        <h2 className="text-3xl md:text-4xl text-white font-bold mt-6 md:mt-8 mb-4">
          Our Vision
        </h2>
        <p className="mt-3 md:mt-5 text-sm md:text-md text-gray-300">
          Empower businesses in underserved regions with reliable, secure, and
          scalable IT infrastructure. Contribute to India's self-reliance by
          addressing data sovereignty challenges and enhancing regional
          infrastructure.
        </p>

        <h2 className="text-3xl md:text-4xl text-white font-bold mt-6 md:mt-8 mb-4">
          Our story
        </h2>
        <p className="mt-3 md:mt-5 text-sm md:text-md text-gray-300">
          Guided by the vision to bridge the technology gap in underserved
          regions like Central India, Recognizing the challenges faced by
          businesses in accessing reliable IT infrastructure, we set out to
          create solutions that combine world-class technology with local
          expertise. Today, we are proud to be a cornerstone of innovation and
          growth in Chhattisgarh, driving progress for businesses across
          industries.
        </p>
      </div>

      {/* Right Section */}
      <div className="w-full lg:w-1/2 flex justify-center items-center">
        <img
          src={globe}
          alt="Globe"
          className="w-4/5 md:w-3/4 lg:w-full h-auto animate-rotate-y" // Added animation class
        />
      </div>
    </div>
  );
};

export default MissionVisionSection;
